import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { matchPath } from 'react-router-dom';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { FallbackContentBody, FallbackContentTitle } from '@bingads-webui-react/fallback-feature';
import {
  withSiteMap, siteMapPropType, findSiteMap,
} from '@bingads-webui-campaign-react/with-site-map';
import { getFallbackPageStyles } from './styles/fallback-page-styles';

const defaultTitle = _TL_('Not Available');

export function isRouteMatch(pathname, route, exact) {
  const extractPattern = new RegExp('/campaign/vnext(/.+)$', 'i');
  const currentLocation = _.last(pathname.match(extractPattern));

  if (_.isEmpty(currentLocation)) {
    return false;
  }

  return route
    ? !!matchPath(currentLocation, {
      path: `/${route}`,
      exact,
    })
    : false;
}

const UnthemedFallbackPage = ({
  title, classes, siteMap, match, i18n,
}) => {
  let fallbackTitle;
  if (title) {
    fallbackTitle = title;
  } else {
    let matchedRoute;
    if (match.params.page) {
      matchedRoute = findSiteMap(siteMap, x => x.route === match.params.page);
    } else {
      matchedRoute = findSiteMap(siteMap, x => isRouteMatch(match.path, x.route, true));
    }

    if (matchedRoute && matchedRoute.name) {
      fallbackTitle = matchedRoute.name;
    }
  }

  fallbackTitle = i18n.getString(fallbackTitle || defaultTitle);

  return (
    <div
      className={classNames([classes.container, 'bingads-webui-campaign-react-fallback-page'])}
    >
      <div className="bingads-webui-campaign-react-fallback-page-title">
        <FallbackContentTitle title={fallbackTitle} />
      </div>
      <div className={classNames([classes.bodyContainer, 'bingads-webui-campaign-react-fallback-page-body'])}>
        <FallbackContentBody />
      </div>
    </div>
  );
};

UnthemedFallbackPage.defaultProps = {
  match: {
    params: {},
  },
  title: undefined,
};

UnthemedFallbackPage.propTypes = {
  title: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      page: PropTypes.string,
    }),
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    bodyContainer: PropTypes.string.isRequired,
  }).isRequired,
};

export const FallbackPage
  = withI18nConsumer(withSiteMap(withDefaultStyles(UnthemedFallbackPage, getFallbackPageStyles)));
